import { beginNavigationFeedback } from '@ui/NavigationFeedback'
import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

type QueryParams = Record<string, string | number | boolean | null | undefined>

export const useCustomRouter = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const createQueryString = useCallback(
    (options: QueryParams) => {
      const params = new URLSearchParams(location.search)

      Object.entries(options).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') {
          params.delete(key) // remove empty values
        } else {
          params.set(key, String(value)) // set or replace
        }
      })

      return params.toString()
    },
    [location.search]
  )

  const push = (path: string = location.pathname, options: QueryParams = {}) => {
    const qs = createQueryString(options)
    const next = qs ? `${path}?${qs}` : path
    const current = `${location.pathname}${location.search}`
    if (next !== current) {
      beginNavigationFeedback()
    }
    navigate(next)
  }

  return { push }
}
